import React, { Component } from 'react';
import { connect } from 'react-redux';

import WakeLockService from "../../../services/WakeLockService";

import endQuizImage from '../../../images/ENDQUIZ.png';
import Config from "../../../config/config";

import '../../../styles/App.css';

export class EndQuiz extends Component {

	constructor(props) {
		super(props);
		
		console.log("EndQuiz::", props);

		WakeLockService.disable();
		const gameEndLoaded = localStorage.getItem("game_end_loaded")
		if (!gameEndLoaded) {
			localStorage.setItem("game_end_loaded", 1);
		} else {
			localStorage.removeItem("game_end_loaded")
			this.goToHome()	
		}
	}

	goToHome() {
		const urlParts = window.location.href.split("/");
		urlParts.splice(-1, 1);
		window.location.href = urlParts.join("/");
	}

	componentDidMount() {
		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'EndQuiz',
			'page_path': '/result'
		});
	}
	
	render() {
		const score = this.props.result.totalScore;
		const position = this.props.result.position;
		const backgroundImage = this.props.result.background || endQuizImage;

		return(
			<div className="voucher endQuiz">								
				<img className="voucherImage" src={backgroundImage} style={{width:"100%"}} alt="winner"/>
				<div className="voucherTexts">
					<div className="winnerDiv">
						<h2>{score}<br/>POINTS</h2>
					</div>

					<div className="winnerInfo">
						{this.props.userName}<br/>
						JE BENT {position}e GEWORDEN!
					</div>
					
					<div className="contactDiv">
						<a target="_blank" href="https://www.linkedin.com/in/boris-boonzajer-flaes-77372228/" rel="noopener noreferrer" className="shareText">Kom in contact met ons om crowdster in te zetten</a>
					</div>
				</div>

			</div>
		)
	}
}
		
function mapStateToProps(state) {
    return {
		result: state.quiz.endQuizResults,
		userName: state.login.userName
    }
}

function mapDispatchToProps(dispatch) {
    return {
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EndQuiz)


// WEBPACK FOOTER //
// ./src/components/pages/EndQuiz/EndQuiz.js